import { GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { standardOperators } from '../../Compounds/UpstackDataGrid/helpers';

export const DefaultPhoneNumberGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    sortable: true,
    width: 200,
    flex: 1,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    width: 300,
    flex: 1,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'phoneType',
    headerName: 'Type',
    sortable: true,
    width: 300,
    flex: 1,
    filterable: true,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  }
];
